import { createAction, props } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import {
  IAssociatedFamilyMembers,
  ICareManagementDocuments,
  ICoverageItem,
  IDocument,
  IGetSubscriptionResult,
  IMemberNetworkResponse,
  IProviderDetailsRequest,
  IProviderDetailsResponse,
  ISnapsRenewalDates,
  ISpendingAccount,
  ISpendingSummary,
  IgetDocumentsPayload
} from './member-details.model';

export const getDelegatedAccessToken = createAction(
  '[Member Details] Retrieve Delegated Access Token',
  props<{ memberId: string }>()
);

export const getDelegatedAccessTokenSuccess = createAction(
  '[Member Details] Retrieve Delegated Access Token SUCCESS',
  props<{ delegatedAccessToken: string }>()
);

export const getDelegatedAccessTokenFailure = createAction(
  '[Member Details] Retrieve Delegated Access Token FAILURE',
  props<{ error: HttpErrorResponse }>()
);

export const removeDelegatedAccessToken = createAction('[Member Details] Remove Delegated Access Token');

export const getMember = createAction('[Member Details] Retrieve Member', props<{ memberId: string }>());

export const getMemberSuccess = createAction('[Member Details] Retrieve Member SUCCESS', props<{ member: any }>());

export const getMemberFailure = createAction(
  '[Member Details] Retrieve Member FAILURE',
  props<{ error: HttpErrorResponse }>()
);

export const getSubscription = createAction(
  '[Member Details] Retrieve Subscription',
  props<{ memberId: string; subscriberNumber: string; shouldCallInvoiceApi: boolean}>()
);

export const getSnapsRenewalDates = createAction(
  '[Member Details] Retrieve SnapsRenewalDates',
  props<{ payload: ISnapsRenewalDates}>()
);

export const getSubscriptionSuccess = createAction(
  '[Member Details] Retrieve Subscription SUCCESS',
  props<{ subscription: IGetSubscriptionResult }>()
);

export const getSubscriptionFailure = createAction(
  '[Member Details] Retrieve Subscription FAILURE',
  props<{ error: HttpErrorResponse }>()
);

export const getAssociatedMemberIds = createAction(
  '[Member Details] Retrieve Associated Member Ids',
  props<{ memberId: string }>()
);

export const getAssociatedMemberIdsSuccess = createAction(
  '[Member Details] Retrieve Associated Member Ids SUCCESS',
  props<{ associatedMemberIds: string[] }>()
);

export const getAssociatedMemberIdsFailure = createAction(
  '[Member Details] Retrieve Additional Member Ids FAILURE',
  props<{ error: HttpErrorResponse }>()
);

export const getHixCodes = createAction('[Member Details] Get HIX Codes', props<{ memberId: string }>());

export const getHixCodesSuccess = createAction('[Member Details] Get HIX Codes SUCCESS', props<{ hixCodes: any }>());

export const getHixCodesFailure = createAction(
  '[Member Details] Get HIX Codes FAILURE',
  props<{ error: HttpErrorResponse }>()
);

export const getPCPHistory = createAction('[Member Details] Retrieve PCP History', props<{ memberId: string }>());

export const getPCPHistorySuccess = createAction(
  '[Member Details] Retrieve PCP History SUCCESS',
  props<{ pcpHistory: any }>()
);

export const getPCPHistoryFailure = createAction(
  '[Member Details] Retrieve Member PCP History FAILURE',
  props<{ error: HttpErrorResponse }>()
);

export const getCOB = createAction(
  '[Member Details] Get Coordination of Benefits',
  props<{ subscriberNumber: string }>()
);

export const getCOBSuccess = createAction(
  '[Member Details] Get Coordination of Benefits SUCCESS',
  props<{ cob: any }>()
);

export const getCOBFailure = createAction(
  '[Member Details] Get Coordination of Benefits FAILURE',
  props<{ error: HttpErrorResponse }>()
);

export const getAssociatedFamily = createAction(
  '[Member Details] Get Associated Family Members',
  props<{ memberId: string }>()
);

export const getAssociatedFamilySuccess = createAction(
  '[Member Details] Get Associated Family Members SUCCESS',
  props<{ familyMembers: IAssociatedFamilyMembers[] }>()
);

export const getAssociatedFamilyFailure = createAction(
  '[Member Details] Get Associated Family Members FAILURE',
  props<{ error: HttpErrorResponse }>()
);

export const getDocuments = createAction('[Member Details] Get Documents', props<{ getDocPayload: IgetDocumentsPayload }>());

export const getDocumentsSuccess = createAction(
  '[Member Details] Get Documents SUCCESS',
  props<{ documents: IDocument[] }>()
);

export const getDocumentsFailure = createAction(
  '[Member Details] Get Documents FAILURE',
  props<{ error: HttpErrorResponse }>()
);

export const updateCoverageFilter = createAction(
  '[Member Details] Update Coverage Filter',
  props<{ status: string }>()
);

export const selectCoverageItem = createAction('[Member Details] Select Coverage Item', props<{ coverage: any }>());

export const clearMemberDetails = createAction('[Member Details] Clear Member Details');

export const fetchSpendingSummary = createAction(
  '[Member Details] Fetch Spending Summary',
  props<{ memberId: string; selectedCoverageItem: any }>()
);

export const fetchSpendingSummarySuccess = createAction(
  '[Member Details] Fetch Spending Summary Success',
  props<{ spendingSummary: ISpendingSummary }>()
);

export const fetchSpendingSummaryError = createAction(
  '[Member Details] Fetch Spending Summary Error',
  props<{ error: any }>()
);

export const fetchSpendingAccounts = createAction(
  '[Member Details] Fetch Spending Accounts',
  props<{ startDate: string }>()
);
export const resetSpendingAccounts = createAction('[Member Details] Reset Spending Accounts');
export const fetchSpendingAccountsSuccess = createAction(
  '[Member Details] Fetch Spending Accounts Success',
  props<{ spendingAccounts: ISpendingAccount[] }>()
);
export const fetchSpendingAccountsFailure = createAction('[Member Details] Fetch Spending Accounts Error');

export const getCareManagementDocuments = createAction(
  '[Member Details] Get Care Management Documents',
  props<{ memberId: string; shouldGetPcsp: boolean }>()
);

export const getCareManagementDocumentsSuccess = createAction(
  '[Member Details] Get Care Management Documents SUCCESS',
  props<{ careManagementDocuments: ICareManagementDocuments[] }>()
);

export const getCareManagementDocumentsFailure = createAction(
  '[Member Details] Get Care Management Documents FAILURE',
  props<{ error: HttpErrorResponse }>()
);

export const fetchMemberPreferences = createAction(
  '[Member Details] fetch Member Preferences',
);
export const fetchMemberPreferencesSuccess = createAction(
  '[Member Details] fetch Member Preferences Success',
  props<{ preferences: any }>()
);

export const fetchMemberPreferencesFailure = createAction(
  '[Member Details] fetch Member Preference Failure',
  props<{ error: HttpErrorResponse }>()
);

export const getMemberNetworks = createAction(
  '[Member Details] Get Member Networks',
  props<{ memberNumber: string }>()
);

export const setMemberNetworks = createAction(
  '[Member Details] Set Member Networks',
  props<{ memberNetworks: IMemberNetworkResponse, status: number }>()
);

export const getProviderDetails = createAction(
  '[Member Details] Get Provider Details',
  props<{ payload: IProviderDetailsRequest }>()
);

export const setProviderDetails = createAction(
  '[Member Details] Set Provider Details',
  props<{ providerDetails: IProviderDetailsResponse }>()
);

export const setProviderDetailsFailure = createAction(
  '[Member Details] Set Provider Details Failure',
  props<{ error: HttpErrorResponse }>()
)
